var exports = {
  "p$": "DMChannelView.module__emptyState___YU50U3",
  "AI": "DMChannelView.module__emptyStateIcon___YU50U3",
  "vo": "DMChannelView.module__emptyStateTitle___YU50U3",
  "Li": "DMChannelView.module__emptyStateDescription___YU50U3",
  "fX": "DMChannelView.module__callParticipantsRow___YU50U3",
  "gN": "DMChannelView.module__compactCallParticipantsRow___YU50U3",
  "Gr": "DMChannelView.module__callParticipant___YU50U3",
  "Gj": "DMChannelView.module__callParticipantAvatar___YU50U3",
  "I9": "DMChannelView.module__callParticipantRinging___YU50U3",
  "rV": "DMChannelView.module__call-participant-ring-pulse___YU50U3",
  "Jn": "DMChannelView.module__callBanner___YU50U3",
  "nY": "DMChannelView.module__callBannerBody___YU50U3",
  "c7": "DMChannelView.module__callBannerResizable___YU50U3",
  "oo": "DMChannelView.module__callControlBarSection___YU50U3",
  "Pf": "DMChannelView.module__callControlBarInner___YU50U3",
  "tX": "DMChannelView.module__callControls___YU50U3",
  "pm": "DMChannelView.module__callBannerMobile___YU50U3",
  "h8": "DMChannelView.module__callBannerMobileLabel___YU50U3",
  "ZI": "DMChannelView.module__callControlsMobile___YU50U3",
  "IX": "DMChannelView.module__compactCallResizeHandle___YU50U3",
  "rF": "DMChannelView.module__compactCallResizePill___YU50U3",
};

module.exports = exports;
